module.exports = __webpack_public_path__ + "img/speaker-1-4.3cd8cdf3.jpg";